import React from 'react';
import { MapPin, Clock, Calendar } from 'lucide-react';

interface VenueAnniversarySectionProps {
  venue: any;
  language: 'en' | 'mr';
}

export const VenueAnniversarySection: React.FC<VenueAnniversarySectionProps> = ({ venue, language }) => {
  return (
    <section className="relative py-24 px-4 bg-gradient-to-b from-transparent via-amber-900/10 to-transparent">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-center text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-rose-400 mb-12">
          {language === 'mr' ? '📍 कार्यक्रम तपशील' : '📍 Celebration Details'}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-amber-500/20 to-rose-500/20 rounded-2xl border-2 border-amber-400/50 p-8 text-center transform hover:scale-105 transition-transform shadow-2xl backdrop-blur-sm">
            <Calendar className="w-12 h-12 mx-auto mb-4 text-amber-300" />
            <p className="text-gray-400 text-sm uppercase font-bold mb-2">
              {language === 'mr' ? 'तारीख' : 'Date'}
            </p>
            <p className="text-2xl font-black text-amber-200">
              {venue.dateStr}
            </p>
            {language === 'mr' && (
              <p className="text-sm text-amber-300 mt-2">{venue.dateMr}</p>
            )}
          </div>

          <div className="bg-gradient-to-br from-rose-500/20 to-amber-500/20 rounded-2xl border-2 border-rose-400/50 p-8 text-center transform hover:scale-105 transition-transform shadow-2xl backdrop-blur-sm">
            <Clock className="w-12 h-12 mx-auto mb-4 text-rose-300" />
            <p className="text-gray-400 text-sm uppercase font-bold mb-2">
              {language === 'mr' ? 'वेळ' : 'Time'}
            </p>
            <p className="text-2xl font-black text-rose-200">
              {venue.time}
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-500/20 to-rose-500/20 rounded-2xl border-2 border-amber-400/50 p-8 text-center transform hover:scale-105 transition-transform shadow-2xl backdrop-blur-sm">
            <MapPin className="w-12 h-12 mx-auto mb-4 text-amber-300" />
            <p className="text-gray-400 text-sm uppercase font-bold mb-2">
              {language === 'mr' ? 'स्थान' : 'Location'}
            </p>
            <p className="text-lg font-black text-amber-200 line-clamp-2">
              {language === 'mr' ? venue.venueMr : venue.venue}
            </p>
            <button className="mt-4 px-4 py-2 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-bold rounded-lg text-sm hover:shadow-lg hover:shadow-blue-500/50 transition-all">
              📍 {language === 'mr' ? 'नक्शा देखा' : 'View Map'}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
